<script>
	// import Home from './home/Home.svelte';
	import { Router, Route } from "svelte-navigator";
	import Encrypt from "./encrypt/Encrypt.svelte";
	import E404 from "./common/E404.svelte";
	import Play from "./play/Play.svelte";
	// import TextPage from './common/TextPage.svelte';
	import Admin from "./admin/Admin.svelte";
	import TeamAdmin from "./admin/TeamAdmin.svelte";
	import WebHapticEngine from "./test/WebHapticEngine.svelte";

	// import ProductLayout from './dist/Product_Layout.svelte';
	// import SignUpGForms from './test/SignUpGForms.svelte';
</script>

<Router>
	<!-- live pages -->
	<!-- <Route path="/" primary={false}>
		<Home />
	</Route> -->

	<Route path="/encrypt" primary={false}>
		<Encrypt />
	</Route>

	<!-- product pages -->
	<!-- <Route path="/roman-plovdiv" primary={false}>
		<ProductLayout game="Philippopolis" />
	</Route>

	<Route path="/antichen-plovdiv" primary={false}>
		<ProductLayout game="AntichenPlovdiv" />
	</Route>

	<Route path="/buden-plovdiv" primary={false}>
		<ProductLayout game="BudenPlovdiv" />
	</Route> -->

	<!-- order status related -->
	<!-- <Route path="/order-success" primary={false}>
		<TextPage page="success" />
	</Route>

	<Route path="/order-cancel" primary={false}>
		<TextPage page="cancel" />
	</Route> -->

	<!-- policies related -->
	<!-- <Route path="/cookies" primary={false}>
		<TextPage page="cookies" />
	</Route>

	<Route path="/privacy" primary={false}>
		<TextPage page="privacy" />
	</Route>

	<Route path="/terms" primary={false}>
		<TextPage page="terms" />
	</Route> -->

	<!-- game related -->
	<Route path="/start" primary={false}>
		<Play />
	</Route>
	<Route path="/haptics" primary={false}>
		<WebHapticEngine></WebHapticEngine>>
	</Route>

	<Route path="/panel" primary={false}>
		<Admin />
	</Route>

	<Route path="/public-panel" primary={false}>
		<TeamAdmin />
	</Route>

	<Route primary={false}>
		<E404 />
	</Route>
</Router>

<style>
</style>
